import React from 'react';
import {connect} from 'react-redux';
import Submenu from './Submenu';
import NoSubmenu from './NoSubmenu';
import checkProperRole from '../../utils/checkProperRole'
import './Sidemenu.css';


class Sidemenu extends React.Component {
 
    createSideMenu() {

        return this.props.sidemenu.map((option)=>{

            var permission = checkProperRole(this.props.userRoles, option.role);

            if (!option.subitems) {

                return (
                    <NoSubmenu 
                        option = {option} 
                        key={option.id} 
                        permission = {permission}
                    />
                )
            } 
            else {
                return (
                    <Submenu 
                        option = {option} 
                        key={option.id} 
                        permission = {permission}
                    />
                )
            }
        });
    }

    render() {

        return (
            <div className = 'sidemenu'>
                {this.createSideMenu()}
            </div>
        )
    }
}

function mapStateToProps(state) {

    return {
        sidemenu: state.sidemenu,
        userRoles: state.userRoles

    }
}

export default connect(mapStateToProps)(Sidemenu);


// WEBPACK FOOTER //
// ./src/containers/sidemenu/Sidemenu.js